import { useContext, createContext } from 'react';

export interface SidebarContextType {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  setIsSidebarOpen: (open: boolean) => void;
}

export const SidebarContext = createContext<SidebarContextType>({
  isSidebarOpen: false,
  toggleSidebar: () => {},
  setIsSidebarOpen: () => {},
});

export const useSidebar = () => useContext(SidebarContext);